import React, { useState } from 'react';
import './ShareLink.css';

const Sharelink = ({ setshowsharelink, postId }) => {
  const link = `https://dmyor.com/s/${postId}`;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  return (
    <div className="sl-overlay" onClick={() => setshowsharelink(false)}>
      <div className="sl-modal" onClick={(e) => e.stopPropagation()}>

        <div className="sl-header">
          <div className="sl-icon"><i className="bx bx-share-alt" /></div>
          <div>
            <h2 className="sl-title">Share Record</h2>
            <p className="sl-sub">Anyone with this link can view the node.</p>
          </div>
          <button className="sl-close-x" onClick={() => setshowsharelink(false)} aria-label="Close">
            <i className="bx bx-x" />
          </button>
        </div>

        <div className="sl-url-row">
          <span className="sl-url-text">{link}</span>
          <button className={`sl-copy-btn${copied ? ' copied' : ''}`} onClick={handleCopy}>
            <i className={`bx ${copied ? 'bx-check' : 'bx-link-alt'}`} />
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>

        <button className="sl-done-btn" onClick={() => setshowsharelink(false)}>Done</button>
      </div>
    </div>
  );
};

export default Sharelink;
